export const GET_SUB_MODULES_FOR_CLIENT_ROLE_REQUEST = "GET_SUB_MODULES_FOR_CLIENT_ROLE_REQUEST";
export const GET_SUB_MODULES_FOR_CLIENT_ROLE_SUCCESS = "GET_SUB_MODULES_FOR_CLIENT_ROLE_SUCCESS";
export const GET_SUB_MODULES_FOR_CLIENT_ROLE_FAILURE = "GET_SUB_MODULES_FOR_CLIENT_ROLE_FAILURE";

export const GET_MODULES_FOR_CLIENT_ROLE_REQUEST = "GET_MODULES_FOR_CLIENT_ROLE_REQUEST";
export const GET_MODULES_FOR_CLIENT_ROLE_SUCCESS = "GET_MODULES_FOR_CLIENT_ROLE_SUCCESS";
export const GET_MODULES_FOR_CLIENT_ROLE_FAILURE = "GET_MODULES_FOR_CLIENT_ROLE_FAILURE";

export const GET_MODULES_FOR_CREATE_REQUEST = "GET_MODULES_FOR_CREATE_REQUEST";
export const GET_MODULES_FOR_CREATE_SUCCESS = "GET_MODULES_FOR_CREATE_SUCCESS";
export const GET_MODULES_FOR_CREATE_FAILURE = "GET_MODULES_FOR_CREATE_FAILURE";


export const CREATE_ADMIN_ROLES_REQUEST = "CREATE_ADMIN_ROLES_REQUEST";
export const CREATE_ADMIN_ROLES_SUCCESS = "CREATE_ADMIN_ROLES_SUCCESS";
export const CREATE_ADMIN_ROLES_FAILURE = "CREATE_ADMIN_ROLES_FAILURE";

export const EDIT_ADMIN_USER_ROLES_REQUEST = "EDIT_ADMIN_USER_ROLES_REQUEST";
export const EDIT_ADMIN_USER_ROLES_SUCCESS = "EDIT_ADMIN_USER_ROLES_SUCCESS";
export const EDIT_ADMIN_USER_ROLES_FAILURE = "EDIT_ADMIN_USER_ROLES_FAILURE";